import React, { useEffect, useState } from "react";
import { fetchBanners, fileUrl } from "../api";

// 300x250 ad slot. Shows an uploaded banner (with destination link) if available,
// otherwise a placeholder ready for monetization.
const BannerAd = ({ label = "Spazio Pubblicitario", id }) => {
  const [banner, setBanner] = useState(null);

  useEffect(() => {
    let active = true;
    fetchBanners(id)
      .then((list) => {
        if (active && list && list.length > 0) setBanner(list[0]);
      })
      .catch(() => {});
    return () => {
      active = false;
    };
  }, [id]);

  if (banner) {
    const img = (
      <img
        src={fileUrl(banner.image)}
        alt="Banner pubblicitario"
        className="block rounded-sm object-cover"
        style={{ width: 300, height: 250 }}
      />
    );
    return (
      <div className="mx-auto" style={{ width: 300 }}>
        {banner.link ? (
          <a href={banner.link} target="_blank" rel="noopener noreferrer">
            {img}
          </a>
        ) : (
          img
        )}
      </div>
    );
  }

  return (
    <div
      data-ad-slot={id}
      className="mx-auto flex flex-col items-center justify-center bg-sq-light border border-dashed border-sq rounded-sm text-center select-none"
      style={{ width: 300, height: 250 }}
    >
      <span className="text-[11px] uppercase tracking-widest text-gray-400">{label}</span>
      <span className="text-sm font-medium text-gray-500 mt-1">300 × 250</span>
      <span className="text-[10px] text-gray-400 mt-3">Disponibile per sponsor</span>
    </div>
  );
};

export default BannerAd;
